const removeTabActiveClass = (parentElem) => {
  const navLinks = parentElem.querySelectorAll('.date-picker__nav-link.is-active');
  const tabPanels = parentElem.querySelectorAll('.date-picker__tabpanel.is-active');
  const activeItems = [...navLinks, ...tabPanels];
  activeItems.forEach((elem) => {
    elem.classList.remove('is-active');
  });
};

attachEvent('.date-picker__nav-link', 'click', (ev) => {
  const button = ev.target;
  const parentElem = button.closest('.date-picker');
  const tabId = button.getAttribute('aria-controls');
  const panelElement = parentElem.querySelector(`#${tabId}`);
  removeTabActiveClass(parentElem);
  button.classList.add('is-active');
  panelElement.classList.add('is-active');
  ev.preventDefault();
});

// eslint-disable-next-line no-unused-vars
const mobiscrollEl = mobiscroll.datepicker('#booking-single', {
  select: 'range', // More info about select: https://docs.mobiscroll.com/5-27-3/javascript/range#methods-select
  display: 'inline',
  pages: windowWidth() <= breakpointSm ? 1 : 2,
  theme: 'ios',
  themeVariant: 'light',
  min: new Date(),
  locale:
    localData && localData.calendar && localData.calendar.locale ? localData.calendar.locale : mobiscroll.localeEs,
});
